<template>
  <div class="pwd-page" :class="device.desktop ? 'pa-6' : 'pa-0'">
    <v-row justify="center">
      <v-col cols="12" md="6" lg="5">
        <v-card class="pwd-card elevation-0">
          <div class="pwd-toolbar">
            <div class="pwd-toolbar__left">
              <div class="pwd-toolbar__icon">
                <v-icon>mdi-lock-reset</v-icon>
              </div>
              <div>
                <div class="pwd-toolbar__title">Ganti Kata Sandi</div>
                <div class="pwd-toolbar__sub">
                  Perbarui kredensial masuk akun gateway
                </div>
              </div>
            </div>
          </div>

          <div class="pwd-body">
            <div class="pwd-tips">
              <v-icon small color="#1f7a57" class="mr-2">mdi-shield-check-outline</v-icon>
              Gunakan minimal 6 karakter. Jangan bagikan kata sandi ke siapapun.
            </div>

            <div class="pwd-field-label">Kata sandi baru</div>
            <v-text-field
              v-model="password"
              outlined
              dense
              hide-details="auto"
              color="#1f7a57"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Masukkan kata sandi baru"
              prepend-inner-icon="mdi-lock-outline"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              class="pwd-field mb-4"
              @click:append="showPassword = !showPassword"
            ></v-text-field>

            <div class="pwd-field-label">Konfirmasi kata sandi</div>
            <v-text-field
              v-model="repassword"
              outlined
              dense
              hide-details="auto"
              color="#1f7a57"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Ulangi kata sandi baru"
              prepend-inner-icon="mdi-lock-check-outline"
              class="pwd-field mb-2"
            ></v-text-field>

            <div v-if="localError" class="pwd-error" role="alert">
              {{ localError }}
            </div>

            <div class="pwd-strength" v-if="password">
              <div class="pwd-strength__bar">
                <span :class="strengthClass"></span>
              </div>
              <div class="pwd-strength__label">{{ strengthLabel }}</div>
            </div>
          </div>

          <div class="pwd-actions">
            <v-btn text class="pwd-btn-ghost" to="/backend/profil-akun">
              Kembali ke profil
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="pwd-btn-primary"
              :loading="saving"
              :disabled="saving"
              @click="postChangePassword"
            >
              <v-icon left small>mdi-content-save-outline</v-icon>
              Simpan Kata Sandi
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "GantiKataSandi",
  data: () => ({
    password: "",
    repassword: "",
    showPassword: false,
    saving: false,
    localError: "",
  }),
  computed: {
    ...mapState(["theme", "http", "device", "snackbar"]),
    strength() {
      const p = this.password || "";
      let score = 0;
      if (p.length >= 6) score++;
      if (p.length >= 10) score++;
      if (/[A-Z]/.test(p) && /[a-z]/.test(p)) score++;
      if (/\d/.test(p)) score++;
      if (/[^A-Za-z0-9]/.test(p)) score++;
      return Math.min(score, 4);
    },
    strengthClass() {
      return ["is-weak", "is-fair", "is-good", "is-strong", "is-strong"][
        this.strength
      ];
    },
    strengthLabel() {
      return ["Sangat lemah", "Lemah", "Cukup", "Baik", "Kuat"][this.strength];
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/",
      title: "GANTI KATA SANDI",
      subtitle: "Perbarui kata sandi akun Anda",
      breadcrumbs: [
        { text: "Utility", disabled: true, href: "" },
        { text: "Ganti Kata Sandi", disabled: false, href: "" },
      ],
      actions: {
        refresh: false,
        add: false,
        edit: false,
        delete: false,
      },
      showtable: false,
    });
  },
  methods: {
    ...mapActions(["setPage"]),
    postChangePassword: async function () {
      this.localError = "";

      if (!this.password) {
        this.localError = "Kata sandi baru wajib diisi";
      } else if (this.password.length < 6) {
        this.localError = "Kata sandi minimal 6 karakter";
      } else if (this.password !== this.repassword) {
        this.localError = "Kata sandi dan konfirmasi tidak sama";
      }

      if (this.localError) {
        this.snackbar.color = "orange";
        this.snackbar.text = this.localError;
        this.snackbar.state = true;
        return;
      }

      try {
        this.saving = true;
        let {
          data: { status, success, message },
        } = await this.http.post("api/utility/change-pwd", {
          password: this.password,
          repassword: this.repassword,
        });

        const ok = status === true || success === true;
        if (!ok) {
          this.localError = message || "Gagal mengubah kata sandi";
          this.snackbar.color = "red";
          this.snackbar.text = this.localError;
          this.snackbar.state = true;
          return;
        }

        this.snackbar.color = this.theme.color || "green";
        this.snackbar.text = message || "Kata sandi berhasil diubah";
        this.snackbar.state = true;
        this.password = "";
        this.repassword = "";
        this.showPassword = false;
      } catch (error) {
        this.localError =
          error?.response?.data?.errors?.[0]?.message ||
          error?.response?.data?.message ||
          "Terjadi kesalahan";
        this.snackbar.color = "red";
        this.snackbar.text = this.localError;
        this.snackbar.state = true;
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.pwd-page {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-fog: #eef6f1;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
  --gw-danger: #b42318;
}

.pwd-card {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid var(--gw-line);
  background: #fff !important;
}

.pwd-toolbar {
  padding: 1rem 1.15rem;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}

.pwd-toolbar__left {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.pwd-toolbar__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
}

.pwd-toolbar__icon .v-icon {
  color: #0b3d2e !important;
}

.pwd-toolbar__title {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
}

.pwd-toolbar__sub {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  color: rgba(244, 251, 247, 0.65);
}

.pwd-body {
  padding: 1.35rem 1.25rem 0.5rem;
}

.pwd-tips {
  display: flex;
  align-items: flex-start;
  gap: 0.15rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: var(--gw-fog);
  border: 1px solid var(--gw-line);
  color: var(--gw-muted);
  font-size: 0.85rem;
  line-height: 1.45;
  margin-bottom: 1.25rem;
}

.pwd-field-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--gw-forest);
  margin-bottom: 0.35rem;
}

.pwd-field >>> .v-input__slot {
  border-radius: 10px !important;
}

.pwd-error {
  margin: 0.5rem 0 0.75rem;
  padding: 0.7rem 0.85rem;
  border-radius: 10px;
  background: rgba(180, 35, 24, 0.08);
  color: var(--gw-danger);
  font-size: 0.88rem;
  font-weight: 600;
}

.pwd-strength {
  margin-top: 0.85rem;
}

.pwd-strength__bar {
  height: 6px;
  border-radius: 99px;
  background: var(--gw-fog);
  overflow: hidden;
}

.pwd-strength__bar span {
  display: block;
  height: 100%;
  width: 25%;
  border-radius: 99px;
  transition: width 0.25s ease, background 0.25s ease;
}

.pwd-strength__bar span.is-weak {
  width: 25%;
  background: #c62828;
}
.pwd-strength__bar span.is-fair {
  width: 45%;
  background: #ef6c00;
}
.pwd-strength__bar span.is-good {
  width: 70%;
  background: #f9a825;
}
.pwd-strength__bar span.is-strong {
  width: 100%;
  background: #1f7a57;
}

.pwd-strength__label {
  margin-top: 0.35rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--gw-muted);
}

.pwd-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.25rem 1.25rem;
  border-top: 1px solid var(--gw-line);
  margin-top: 1rem;
}

.pwd-btn-primary {
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5) !important;
  color: #0b3d2e !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 700 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
}

.pwd-btn-ghost {
  text-transform: none !important;
  letter-spacing: 0 !important;
  color: var(--gw-leaf) !important;
  font-weight: 700 !important;
}

@media (max-width: 600px) {
  .pwd-actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }
}
</style>
